export const existeDescripcionMalla = (mallas, descripcion, excludeId = null) =>
  mallas?.some(
    (m) =>
      !m.eliminado &&
      m.id !== excludeId &&
      m.descripcion.trim().toLowerCase() === descripcion.trim().toLowerCase(),
  ) ?? false;
